import { Component } from '@angular/core';

@Component({
  selector: 'app-order-exception-table-skeleton',
  standalone: true,
  templateUrl: './order-exception-table-skeleton.component.html',
  styleUrl: './order-exception-table-skeleton.component.scss'
})
export class OrderExceptionTableSkeletonComponent {
  readonly numberOfCols = new Array(6);
  readonly numberOfRows = new Array(5);
}
